import { render, staticRenderFns } from "./AdminNavigationHelper.vue?vue&type=template&id=167798e0&"
import script from "./AdminNavigationHelper.vue?vue&type=script&lang=js&"
export * from "./AdminNavigationHelper.vue?vue&type=script&lang=js&"
import style0 from "./AdminNavigationHelper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBadge,VIcon,VImg,VList,VListItem,VListItemContent,VListItemTitle,VNavigationDrawer})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('167798e0')) {
      api.createRecord('167798e0', component.options)
    } else {
      api.reload('167798e0', component.options)
    }
    module.hot.accept("./AdminNavigationHelper.vue?vue&type=template&id=167798e0&", function () {
      api.rerender('167798e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/navigation/AdminNavigationHelper.vue"
export default component.exports